import React from "react";
// import ContactForm from "../Contact/contactForm";
import { Link } from "react-router-dom";
import RegForm from "../Register/RegForm";

class Register extends React.Component {
  render() {
    return (
      <div className="contact">
        <div className="row mx-0">
          <div className="col-12 col-xl-6">
            <RegForm />
          </div>
          <div className="col-6 d-none d-xl-block contactRight">
            <Link to="/" className="btn closeBtn">
              X
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;
